import { useDispatch, useSelector } from "react-redux";
import { IoClose } from "react-icons/io5";
import { FaCheckCircle, FaPauseCircle, FaHourglassHalf, FaTimesCircle } from "react-icons/fa";
import { FiFlag } from "react-icons/fi";
import { useState } from "react";
import { addToast } from "../../../../Redux/Slices/toast-slice";
import Loader from "../../../Loader/Loader";
import { fetchApi } from "../../../../utlis/axios";

const statusIcons = {
  completed: { icon: <FaCheckCircle className="text-green-500 " />, label: "Completed" },
  paused: { icon: <FaPauseCircle className="text-yellow-500" />, label: "Paused" },
  in_progress: { icon: <FaHourglassHalf className="text-orange-500" />, label: "In Progress" },
  canceled: { icon: <FaTimesCircle className="text-red-500" />, label: "Canceled" },
};

const MilestoneView = ({ mileStoneId, setMilestoneView, setMileStoneModalOpen, setEditingMileStone }) => {
  const { theme } = useSelector((state) => state.theme);
  const { userInfo } = useSelector((state) => state?.auth || {});
  const isDark = theme === "dark";
  const dispatch=useDispatch()
  
  const [isDeleting , setIsDeleting] = useState(false);
  const [mileStone, setMileStone] = useState(null);
  const [loading, setLoading]=useState(true)

  const getMileStoneData=async()=>{
    setLoading(true)
    try{
      const response = await fetchApi.get(`project-milestones/${mileStoneId}/`,{
        headers:{
          'Authorization':`Bearer ${userInfo?.access_token}`
        }
      });
      setMileStone(response.data);
    }catch(error){
        dispatch(addToast({message:"Error fetching milestone data",type:"error"}))
    }finally{
      setLoading(false)
    }
  }

  useState(()=>{
    getMileStoneData()
  },[])

  const handleDeleteProject = async (item) => {
    setIsDeleting(true);
    try{
    const res= await fetchApi.delete(`project-milestones/${mileStoneId}/`,{
      headers:{
        'Authorization':`Bearer ${userInfo?.access_token}`
      }
    });
    if(res.status===200){
      dispatch(addToast({message:"Milestone deleted successfully",type:"success"}))
    }
    }catch(err){
      dispatch(addToast({message:"Error deleting milestone",type:"error"}))
    }finally{

      setIsDeleting(false);
      setMilestoneView(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/40 z-[1050] flex justify-center items-center px-4">
      <div className={`max-w-md w-full rounded-[20px] shadow-lg overflow-hidden relative transition-all
        ${isDark ? "bg-[#1e1e1e] text-white" : "bg-[#FFFFFF] text-black"}`}>
        
        {loading ? <div className="flex justify-center items-center min-h-[30vh]"><Loader/></div> :
        <div>
        {/* Close Button */}
        <button onClick={()=>setMilestoneView(false)} className={`absolute top-3 right-3 text-xl rounded-full hover:text-red-600 p-2 ${theme === 'dark' ?'bg-gray-800':'bg-gray-200'}`}>
          <IoClose className="w-6 h-6"/>
        </button>
{!mileStone ? <div className="flex justify-center items-center min-h-[30vh]">Please try again to reload page</div>: 
        <div className="p-6 space-y-4">
          {/* Title */}
          <h2 className="text-xl font-semibold mt-3 mb-2 w-full items-center">{mileStone?.title}</h2>

          {/* Info */}
          <div className="flex flex-col gap-4 text-base">
            <div className="w-full flex items-center justify-between">
              <p className="">Budget</p>
              <p className="font-medium">{'44'} USD</p>
            </div>
            <div className="flex w-full justify-between items-center text-lg font-medium">
              <p className="">Status</p>
              <div className="flex items-center gap-1 font-medium">
                     {statusIcons[mileStone?.status]?.icon} 
                    <span>{statusIcons[mileStone?.status]?.label}</span>
                  </div>
            </div>
            <div className="w-full flex justify-between items-center text-lg font-medium">
              <p className="">Duration</p>
              <p className="whitespace-nowrap font-medium ">{mileStone.start_date} to {mileStone.end_date}</p>
            </div>
          </div>

          

          {/* Description */}
          <div>
            <p className="text-gray-500 mb-1 text-lg">Milestone Description</p>
            <p className={`text-sm p-3 rounded-md border ${isDark ? "bg-[#2e2e2e] border-[#555657]" : "bg-[#F5F6FA] border-[#D8D8D8]"}`} dangerouslySetInnerHTML={{ __html: mileStone.description}}>
            </p>
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-4 items-center mt-4 w-full">
            <button
              onClick={()=>handleDeleteProject(mileStone)} disabled={isDeleting}
              className="px-4 py-2 rounded-full w-1/2 border border-gray-300 hover:border-red-600 text-sm"
            >
              {isDeleting ? 'Deleting...' : 'Delete'}
            </button>
            <button
              onClick={()=>{
                setEditingMileStone(mileStone);
                setMileStoneModalOpen(true);
                setMilestoneView(false);
              }}
              className="px-4 py-2 w-1/2 rounded-lg heroButton"
            >
              Edit
            </button>
          </div>
        </div>}
        </div>}
      </div>
    </div>
  );
};

export default MilestoneView;
